import React from 'react';
import { FadeIn } from './FadeIn';
import { UserMinusIcon, TrendingUpIcon, UsersIcon, DollarSignIcon } from 'lucide-react';
export function PainStories() {
  const pains = [{
    icon: <UserMinusIcon className="w-8 h-8 text-red-400" data-id="element-101" />,
    title: 'El abandono silencioso',
    text: 'Un alumno te dice "lo pienso" y nunca más vuelve. Vos sabés que progresó. Pero no tenés cómo demostrárselo. No hay papel, no hay datos, no hay evidencia. Solo tu palabra. Y tu palabra compite con el precio del profe de al lado que cobra menos.'
  }, {
    icon: <TrendingUpIcon className="w-8 h-8 text-orange-400" data-id="element-102" />,
    title: 'La pregunta incómoda',
    text: 'Otro alumno lleva tres meses con vos y un día te pregunta si está mejorando. Y vos le respondés que sí, que se nota, que va bien. Pero en el fondo los dos saben que eso no es una respuesta. Es una opinión. Y las opiniones no retienen alumnos. Los datos sí.'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-yellow-400" data-id="element-103" />,
    title: 'El malabarismo de niveles',
    text: 'Un grupo de distintos niveles llega al miércoles a las 19 y vos tenés que hacer malabarismo para que el avanzado no se aburra y el básico no se frustre. Sin sistema, cada clase es una improvisación nueva. Con sistema, es una variante prediseñada de 30 segundos.'
  }, {
    icon: <DollarSignIcon className="w-8 h-8 text-padel-lime" data-id="element-104" />,
    title: 'El techo de cristal',
    text: 'Y el precio. Siempre el precio. Llevás dos años cobrando lo mismo porque cada vez que pensás en subirlo aparece la misma pregunta: ¿y si se van? ¿Cómo lo justifico? ¿Qué argumento tengo? La respuesta es que no tenés argumento. Todavía.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-padel-dark" data-id="element-105">
      <div className="max-w-5xl mx-auto" data-id="element-106">
        <FadeIn data-id="element-107">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-108">
            Y mientras tanto,{' '}
            <span className="text-red-400" data-id="element-109">pasan cosas que duelen.</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-110">
          {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-111">
              <div className="bg-padel-surface border border-padel-muted p-6 sm:p-8 rounded-2xl h-full hover:border-padel-lime/30 transition-colors" data-id="element-112">
                <div className="bg-padel-dark w-16 h-16 rounded-xl flex items-center justify-center mb-6 border border-padel-muted" data-id="element-113">
                  {pain.icon}
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-4" data-id="element-114">
                  {pain.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-115">{pain.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}